import { PostModel } from "common/models/baseModel";
import { create } from "zustand";

import { GridPaginationModel, GridSortModel } from "@mui/x-data-grid";
import { IAchievementGridFilter } from "../api/types";

export interface AchievementStore {
  postModel: PostModel<IAchievementGridFilter>;
  handleFiltering: (filter: IAchievementGridFilter) => void;
  handlePagination: (pageModel: GridPaginationModel) => void;
  handleSorting: (sortModel: GridSortModel) => void;
}

const useAchievementStore = create<AchievementStore>()((set) => ({
  postModel: {
    pagingModel: {
      page: 0,
      pageSize: 100,
    },
    filterModel: {
      title: null,
      memberName: null,
      achievementType: null,
      verificationStatus: null,
      dateOfAchievement: null,
      location: null,
      designation: null
    },
  },
  handlePagination: (pageModel: GridPaginationModel) =>
    set((state) => ({
      postModel: { ...state.postModel, pagingModel: { ...pageModel } },
    })),
  handleFiltering: (filterModel: IAchievementGridFilter) =>
    set((state) => ({
      postModel: { ...state.postModel, filterModel: { ...filterModel } },
    })),
  handleSorting: (sortModel: GridSortModel) =>
    set((state) => ({
      postModel: { ...state.postModel, sortModel: [...sortModel] },
    })),
}));

export default useAchievementStore;
